module.exports = __webpack_public_path__ + "assets/b80.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b80.png
// module id = 672
// module chunks = 0